module.exports = __webpack_public_path__ + "static/chart@2x-89276586f373e5f52a0842fe7d1808de.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/prototyping/chart@2x.png
// module id = 2611
// module chunks = 168707334958949